import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from 'motion/react';
import { Smartphone, Zap, Users, Target, Layers, Layout, TrendingUp, Code, Smartphone as MobileIcon, MousePointerClick } from 'lucide-react';
import Image from 'react-bootstrap/Image';
import AppLink from '../assets/images/Marketing/AppLink.png';
import flutterSolution from '../assets/images/Marketing/flutter-solution1.jpg';
const AppLinkFlutterSDK = () => {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap');
        .applink-page { font-family: 'Outfit', sans-serif; background-color: #fff; color: #0f172a; }
        .applink-page * { font-family: 'Outfit', sans-serif; }

        /* Hero Section */
        .hero-section-applink {
          padding: 80px 0;
          background: #fff;
          position: relative;
          overflow: hidden;
        }

        .hero-image-wrapper {
          position: relative;
          display: inline-block;
          z-index: 1;
        }

        .hero-shape {
          position: absolute;
          z-index: -1;
          opacity: 0.1;
          animation: float 6s ease-in-out infinite;
        }

        .hero-shape-square {
          width: 120px;
          height: 120px;
          background: #ee0000;
          top: -15px;
          right: -15px;
          border-radius: 20px;
          transform: rotate(15deg);
        }

        .hero-shape-square-2 {
          width: 100px;
          height: 100px;
          background: #067bb1;
          bottom: -20px;
          left: -20px;
          border-radius: 16px;
          transform: rotate(-15deg);
        }

        @keyframes float {
          0%, 100% { transform: translate(0, 0) rotate(15deg); }
          50% { transform: translate(10px, -20px) rotate(20deg); }
        }

        @keyframes float-tri {
          0%, 100% { transform: translate(0, 0) rotate(-15deg); }
          50% { transform: translate(-15px, 15px) rotate(-10deg); }
        }
        
        .hero-tag-applink { 
          display:inline-flex; 
          align-items:center; 
          gap:8px; 
          padding:6px 12px; 
          border-radius:999px; 
          background:#ffefef; 
          color:#ee0000; 
          border:1px solid #ffd4d4; 
          font-weight:700; 
          font-size:12px; 
          margin-bottom: 16px;
          
        }

        .hero-title-applink {
          font-size: 42px;
          font-weight: 800;
          color: #000;
          margin-bottom: 12px;
          line-height: 1.1;
          letter-spacing: -0.02rem;
          
        }
        
        .highlight-red { color:#ee0000; font-weight:700; }

        .hero-subtitle-applink {
          font-size: 20px;
          color: #000;
          font-weight: 700;
          margin-bottom: 24px;
          letter-spacing: -0.01rem;
          max-width: 100%;
          font-size: 20px;
  color: #2c354c;
  font-weight: 400;
  margin-bottom: 24px;
  letter-spacing: -0.01rem;
  max-width: 100%;
        }

        .hero-description-applink {
          font-size: 16px;
          line-height: 1.6;
          color: #334155;
          margin-bottom: 32px;
          max-width: 90%;
        }

        .btn-red-applink { 
          text-decoration:none;
          background:#ee0000; 
          color:#fff; 
          border:none; 
          border-radius:12px; 
          padding:12px 24px; 
          font-weight:700; 
          box-shadow:0 12px 24px rgba(238,0,0,0.18); 
          transition: all 0.3s ease;
          display: inline-block;
        }
        .btn-red-applink:hover {
          background: #cc0000;
          transform: translateY(-2px);
          color: #fff;
        }

        /* Problem Section Styles (Revamped to match AWS Middleware) */
        .problem-section-applink {
          padding: 80px 0;
          background: rgb(226, 241, 254);
          position: relative;
          overflow: hidden;
        }
        
        // .ps-bg-orb {
        //   position: absolute;
        //   width: 400px;
        //   height: 400px;
        //   background: radial-gradient(circle, rgba(227, 24, 55, 0.05) 0%, transparent 70%);
        //   border-radius: 50%;
        //   filter: blur(100px);
        //   z-index: 0;
        //   pointer-events: none;
        // }
        // .ps-orb-tl { top: -100px; left: -100px; }
        // .ps-orb-br { bottom: -100px; right: -100px; }

        .ps-pill {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 6px 16px;
          border-radius: 999px;
          background: #ffefef;
          color: #ee0000;
          border: 1px solid #ffd4d4;
          font-size: 12px;
          font-weight: 700;
          margin-bottom: 15px;
          text-transform: uppercase;
          letter-spacing: 0.05em;
        }
        
        .ps-title {
          font-size: 42px;
          font-weight: 800;
          color: #000;
          margin-bottom: 15px;
          letter-spacing: -0.02em;
        }

        .ps-text {
          font-size: 18px;
          line-height: 1.6;
          color: #4b5563;
          margin-bottom: 20px;
        }

        .problem-card-modern {
          background: #fff;
          border-radius: 24px;
          padding: 32px 24px;
          border: 1px solid #e2e8f0;
          height: 100%;
          position: relative;
          overflow: hidden;
          transition: all 0.4s ease;
          z-index: 1;
        }
        .problem-card-modern:hover {
          border-color: #fee2e2;
          transform: translateY(-8px);
          box-shadow: 0 20px 40px rgba(0,0,0,0.06);
        }
        
        .problem-icon-box {
          width: 64px;
          height: 64px;
          border-radius: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 24px;
          position: relative;
          z-index: 2;
          background: #ee0000;
          color: #fff;
          box-shadow: 0 8px 20px rgba(238, 0, 0, 0.25);
          transition: transform 0.3s ease;
        }
        .problem-card-modern:hover .problem-icon-box {
          transform: scale(1.1) rotate(-5deg);
        }

        .problem-card-title {
          font-size: 19px;
          font-weight: 700;
          line-height: 1.4;
        }

        .shape-tr-circle { 
            position: absolute; 
            top: -60px; 
            right: -60px; 
            width: 150px; 
            height: 150px; 
            border-radius: 50%; 
            background: transparent;
            border: 1px solid rgba(238, 0, 0, 0.1);
            z-index: 0;
            pointer-events: none;
        }
        
        .shape-tr-inner {
            position: absolute;
            top: -30px;
            right: -30px;
            width: 120px;
            height: 120px;
            border-radius: 50%;
            background: radial-gradient(circle at center, rgba(238, 0, 0, 0.04) 0%, transparent 70%);
            z-index: 0;
        }

        /* Solution Section Styles */
        .solution-section-applink {
          padding: 80px 0;
          background: #fff;
        }
        
        .solution-container {
          background: #effdff;
          border-radius: 32px;
          padding: 60px;
          border: 1px solid rgba(56, 164, 229, 0.2);
          box-shadow: 0 20px 50px -12px rgba(24, 132, 227, 0.1);
        }

        /* Capabilities Section Styles (Revamped to match Data Dedup) */
        .capabilities-section-dedup {
          padding: 0px 0 80px 0;
          background-color: #fff;
          position: relative;
          overflow: hidden;
        }

        .cap-feature-row {
          display: flex;
          align-items: center;
          padding: 32px;
          background: #fff;
          border-radius: 24px;
          border: 1px solid #e2e8f0;
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          height: 100%;
          position: relative;
          overflow: hidden;
          z-index: 1;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
        }
        
        .cap-feature-row:hover {
          border-color: #fee2e2;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
          transform: translateY(-5px);
        }

        .cap-feature-row .shape-tr-circle { 
            position: absolute; 
            top: -60px; 
            right: -60px; 
            width: 150px; 
            height: 150px; 
            border-radius: 50%; 
            background: transparent;
            border: 1px solid rgba(238, 0, 0, 0.1);
            z-index: 0;
            pointer-events: none;
        }
        
        .cap-feature-row .shape-tr-inner {
            position: absolute;
            top: -30px;
            right: -30px;
            width: 120px;
            height: 120px;
            border-radius: 50%;
            background: radial-gradient(circle at center, rgba(238, 0, 0, 0.04) 0%, transparent 70%);
            z-index: 0;
        }

        .cap-feature-icon-box {
          width: 64px;
          height: 64px;
          border-radius: 16px;
          background: #ffefef;
          color: #ee0000;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 24px;
          flex-shrink: 0;
          transition: all 0.4s ease;
          position: relative;
          z-index: 2;
        }
        
        .cap-feature-row:hover .cap-feature-icon-box {
          background: #ee0000;
          color: #fff;
          transform: rotate(-10deg);
        }

        .cap-feature-title {
          font-size: 18px;
          font-weight: 700;
          color: #0f172a;
          margin-bottom: 0;
          line-height: 1.4;
          transition: color 0.3s ease;
          position: relative;
          z-index: 2;
        }
        
        .cap-feature-row:hover .cap-feature-title {
          color: #ee0000;
        }

        /* Business Impact Section (Revamped to Dashboard Style) */
        .impact-section-applink {
          padding: 80px 0;
          background-color: rgb(226, 241, 254);
          position: relative;
          overflow: hidden;
        }
        
        .impact-stat-card {
          background: #fff;
          border-radius: 20px;
          padding: 32px;
          border: 1px solid #e2e8f0;
          height: 100%;
          transition: all 0.4s ease;
          display: flex;
          flex-direction: column;
          justify-content: center;
          position: relative;
          overflow: hidden;
          z-index: 1;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
        }
        .impact-stat-card:hover {
          transform: translateY(-8px);
          border-color: #fee2e2;
          box-shadow: 0 20px 40px rgba(0,0,0,0.06);
        }
        
        .impact-stat-card .shape-tr-circle { 
            position: absolute; 
            top: -60px; 
            right: -60px; 
            width: 150px; 
            height: 150px; 
            border-radius: 50%; 
            background: transparent;
            border: 1px solid rgba(238, 0, 0, 0.1);
            z-index: 0;
            pointer-events: none;
        }
        
        .impact-stat-card .shape-tr-inner {
            position: absolute;
            top: -30px;
            right: -30px;
            width: 120px;
            height: 120px;
            border-radius: 50%;
            background: radial-gradient(circle at center, rgba(238, 0, 0, 0.04) 0%, transparent 70%);
            z-index: 0;
        }
        
        .impact-icon-box {
          width: 64px;
          height: 64px;
          border-radius: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 24px;
          position: relative;
          z-index: 2;
          background: #ee0000;
          color: #fff;
          box-shadow: 0 8px 20px rgba(238, 0, 0, 0.25);
          transition: all 0.3s ease;
        }
        .impact-stat-card:hover .impact-icon-box {
          transform: scale(1.1) rotate(-5deg);
          box-shadow: 0 12px 24px rgba(238, 0, 0, 0.4);
        }
        
        .impact-stat-title {
          font-size: 20px;
          font-weight: 800;
          color: #0f172a;
          margin-bottom: 0;
          transition: color 0.3s ease;
        }
        .impact-stat-card:hover .impact-stat-title {
          color: #ee0000;
        }

        /* Ideal Section Styles */
        .ideal-section-applink {
          padding: 80px 0;
          background: #fff;
        }

        .ideal-card {
          background: #fff;
          border: 2px solid #e5e7eb;
          border-radius: 24px;
          padding: 48px 32px;
          position: relative;
          overflow: hidden;
          transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
          height: 100%;
          box-shadow:0 10px 30px rgba(0, 0, 0, 0.05);
        }
        .ideal-card:hover {
          border-color: rgba(238, 0, 0, 0.3);
          transform: translateY(-5px);
          box-shadow: 0 20px 40px -12px rgba(238, 0, 0, 0.15);
        }
        
        .ideal-icon-box {
          width: 64px;
          height: 64px;
          border-radius: 16px;
          background: linear-gradient(135deg, #ee0000, #ee0000);
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 24px;
          color: #fff;
        }

        .shape-diamond { 
          position: absolute; 
          top: 20px; 
          right: 20px; 
          width: 12px; 
          height: 12px; 
          background: #fee2e2; 
          transform: rotate(45deg); 
          opacity: 0; 
          transition: all 0.4s ease; 
        }
        .problem-card-modern:hover .shape-diamond, 
        .ideal-card:hover .shape-diamond,
        .cap-feature-row:hover .shape-diamond { 
          opacity: 1; 
          transform: rotate(45deg) translate(10px, -10px); 
        }
      `}</style>

      <div className="applink-page">
        {/* Hero Section */}
        <section className="hero-section-applink">
          <Container>
            <Row className="align-items-center justify-content-between">
              <Col lg={7}>
                <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
                  {/* <div className="hero-tag-applink">⚡ Salesforce Personalization SDK</div> */}
                  <h1 className="hero-title-applink">
                    Deliver Real-Time Salesforce Personalization in Mobile Apps with <span className="highlight-red">AppLink™</span>
                  </h1>
                  <p className="hero-subtitle-applink"><span className="highlight-red">AppLink™</span> is a Flutter SDK that enables mobile applications to integrate directly with Salesforce personalization engines for real-time targeted experiences.</p>
                  <a href="/contact" className="btn-red-applink">Schedule a Demo</a>
                </motion.div>
              </Col>
              <Col lg={5} className="text-center d-none d-lg-block">
                <div className="hero-image-wrapper">
                  <div className="hero-shape hero-shape-square"></div>
                  <div className="hero-shape hero-shape-square-2" style={{ animationName: 'float-tri' }}></div>
                  <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 1 }}
                  >
                    <Image src={AppLink} alt="AppLink" className="img-fluid" />
                  </motion.div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Challenge Section */}
        <section className="problem-section-applink">
          <div className="ps-bg-orb ps-orb-tl"></div>
          <div className="ps-bg-orb ps-orb-br"></div>
          <Container>
            <div className="text-center mb-5">
              {/* <div className="ps-pill">The Challenge</div> */}
              <h2 className="ps-title">The Challenge</h2>
              <p className="ps-text">
                While websites benefit from advanced personalization, mobile apps often lack similar functionality due to:
              </p>
            </div>
            <Row className="g-4 mb-0">
              {[
                { icon: <Layers />, title: "Limited integration between mobile apps and personalization engines" },
                { icon: <MousePointerClick />, title: "Fragmented user session tracking" },
                { icon: <Code />, title: "High development effort required to deploy personalized content" },
                { icon: <Users />, title: "Inconsistent customer experiences across web and mobile channels" }
              ].map((item, idx) => (
                <Col key={idx} md={6} lg={3}>
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: idx * 0.1 }}
                    className="problem-card-modern"
                  >
                    <div className="shape-tr-circle"></div>
                    <div className="shape-tr-inner"></div>
                    <div className="shape-diamond"></div>
                    <div className="problem-icon-box">{item.icon}</div>
                    <h4 className="problem-card-title mb-0">{item.title}</h4>
                  </motion.div>
                </Col>
              ))}
            </Row>

          </Container>
        </section>

        {/* Solution Section */}
        <section className="solution-section-applink">
          <Container>
            <motion.div initial={{ opacity: 0, scale: 0.95 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} className="solution-container">
              <Row className="align-items-center">
                <Col lg={8}>
                  {/* <div className="ps-pill">Comsense Solution</div> */}
                  <h2 className="ps-title">Comsense Solution</h2>
                  <p className="fs-5 mb-4 text-muted" style={{ fontWeight: '400' }}>
                    AppLink™ was developed to bridge Salesforce personalization platforms with modern Flutter-based mobile applications.
                  </p>
                  <p className="text-muted mb-4">
                    The SDK enables real-time behavioral tracking, session management, and dynamic content delivery—allowing businesses to extend personalization strategies into mobile environments.
                  </p>
                  <p className="fs-5 mb-0">
                    This ensures customers receive <span className="highlight-red">consistent, intelligent experiences across all digital touchpoints.</span>
                  </p>

                </Col>
                <Col lg={4} className="text-center d-none d-lg-block">
                  <Image src={flutterSolution} alt="flutter-solution" className="img-fluid" />

                </Col>
              </Row>
            </motion.div>
          </Container>
        </section>

        {/* Key Capabilities */}
        <section className="capabilities-section-dedup">
          <Container>
            <div className="text-center mb-5">
              {/* <div className="ps-pill">Core Features</div> */}
              <h2 className="ps-title">Key Capabilities</h2>
            </div>
            <Row className="g-4">
              {[
                { icon: <Target size={32} />, text: "Direct integration with Salesforce personalization infrastructure." },
                { icon: <MousePointerClick size={32} />, text: "Capture app interactions: navigation, product views, and purchases." },
                { icon: <Zap size={32} />, text: "Deliver targeted content and offers dynamically within mobile apps." },
                { icon: <Layout size={32} />, text: "Plug-and-play components: personalized banners, carousels, and recommendations." }
              ].map((item, idx) => (
                <Col key={idx} md={6}>
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: idx * 0.1 }}
                    className="cap-feature-row"
                  >
                    <div className="shape-tr-circle"></div>
                    <div className="shape-tr-inner"></div>
                    <div className="shape-diamond"></div>
                    <div className="cap-feature-icon-box">
                      {item.icon}
                    </div>
                    <div className="cap-feature-content">
                      <h4 className="cap-feature-title">{item.text}</h4>
                    </div>
                  </motion.div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        {/* Business Impact */}
        <section className="impact-section-applink">
          <Container>
            <Row className="align-items-center">
              <Col lg={4}>
                <div className="mb-5 mb-lg-0">
                  {/* <div className="ps-pill">Business Impact</div> */}
                  <h2 className="ps-title">Measurable Results</h2>
                  <p className="ps-text">
                    Organizations using AppLink™ achieve real-time mobile personalization and higher engagement rates through unified digital experiences.
                  </p>

                </div>
              </Col>

              <Col lg={8}>
                <Row className="g-4">
                  {[
                    { icon: <Smartphone size={32} />, title: "Real-time mobile personalization" },
                    { icon: <TrendingUp size={32} />, title: "Higher mobile engagement and conversion rates" },
                    { icon: <Layers size={32} />, title: "Unified personalization across web and mobile" },
                    { icon: <Zap size={32} />, title: "Faster campaign deployment" }
                  ].map((item, idx) => (
                    <Col md={6} key={idx}>
                      <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: idx * 0.1 }}
                        className="impact-stat-card"
                      >
                        <div className="shape-tr-circle"></div>
                        <div className="shape-tr-inner"></div>
                        <div className="shape-diamond"></div>
                        <div className="impact-icon-box">
                          {item.icon}
                        </div>
                        <h4 className="impact-stat-title mb-0 pb-0">{item.title}</h4>
                      </motion.div>
                    </Col>
                  ))}
                </Row>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Ideal For */}
        <section className="ideal-section-applink">
          <Container>
            <div className="text-center mb-5">
              {/* <div className="ps-pill">Ideal For</div> */}
              <h2 className="ps-title">Who is it for?</h2>
            </div>
            <Row className="justify-content-center g-4">
              {[
                { icon: <MobileIcon />, title: "Mobile-First", desc: "Digital businesses" },
                { icon: <Code />, title: "Flutter Teams", desc: "Product teams" },
                { icon: <Layers />, title: "Salesforce Users", desc: "Interaction Studio" }
              ].map((item, i) => (
                <Col md={4} key={i}>
                  <div className="ideal-card p-4 d-flex align-items-center">
                    <div className="shape-diamond"></div>
                    <div className="ideal-icon-box mb-0 me-4">{item.icon}</div>
                    <div>
                      <h5 className="fw-800 mb-1">{item.title}</h5>
                      <p className="text-muted small mb-0">{item.desc}</p>
                    </div>
                  </div>
                </Col>
              ))}

            </Row>
            <div className="text-center">
              <div className="d-none d-lg-block mt-5">
                <a href="/contact" className="btn-red-applink">Discover AppLink</a>
              </div>
            </div>
          </Container>
        </section>


      </div>
    </>
  );
};

export default AppLinkFlutterSDK;
